// src/components/Tour.js
import Shepherd from 'shepherd.js';
import 'shepherd.js/dist/css/shepherd.css';

const Tour = () => {
  const initTour = () => {
    const tour = new Shepherd.Tour({
      useModalOverlay: true,
      defaultStepOptions: {
        cancelIcon: {
          enabled: true
        },
        classes: 'shadow-md bg-purple-dark',
        scrollTo: { behavior: 'smooth', block: 'center' }
      }
    });

    tour.addStep({
      title: 'Welcome to CAMeleon',
      text: `Let's take a quick tour of the main features.`,
      attachTo: {
        element: '#cameleon-logo',
        on: 'bottom'
      },
      buttons: [
        {
          text: 'Next',
          action: tour.next
        }
      ]
    });

    tour.addStep({
      title: 'Import STL',
      text: 'Click here to import your STL file.',
      attachTo: {
        element: '#importStlButton',
        on: 'bottom'
      },
      buttons: [
        {
          text: 'Back',
          action: tour.back
        },
        {
          text: 'Next',
          action: tour.next
        }
      ]
    });

    tour.addStep({
      title: 'Search',
      text: 'Use this search bar to filter the workflows. Click on the search bar to reveal tags. You can filter workflows by selecting one or more tags.',
      attachTo: {
        element: '#filterInput',
        on: 'bottom'
      },
      buttons: [
        {
          text: 'Back',
          action: tour.back
        },
        {
          text: 'Next',
          action: tour.next
        }
      ]
    });

    tour.addStep({
      title: 'Workflows',
      text: 'Here you can see all available workflows. Drag and drop items into the viewer area on the right to add them.',
      attachTo: {
        element: '#content',
        on: 'right'
      },
      modalOverlayOpeningPadding: 5,
      modalOverlayOpeningRadius: 10,
      buttons: [
        {
          text: 'Back',
          action: tour.back
        },
        {
          text: 'Next',
          action: tour.next
        }
      ]
    });

    tour.addStep({
      title: 'Drag and Drop',
      text: 'You can drag and drop workflow items into this area to view them.',
      attachTo: {
        element: '#viewer-container',
        on: 'left'
      },
      buttons: [
        {
          text: 'Back',
          action: tour.back
        },
        {
          text: 'Next',
          action: tour.next
        }
      ]
    });

    tour.addStep({
      title: 'Multi-item Drag and Drop',
      text: 'Try dragging multiple items into the viewer area. You can add up to 4 items at once. To do this, drag one item, then drag another without clicking elsewhere in between drags.',
      attachTo: {
        element: '#viewer-container',
        on: 'left'
      },
      buttons: [
        {
          text: 'Back',
          action: tour.back
        },
        {
          text: 'Finish',
          action: tour.complete
        }
      ]
    });

    return tour;
  };

  const startTour = () => {
    const tour = initTour();
    tour.start();
  };

  return {
    startTour
  };
};

export default Tour;